//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "VillageResources",
};
